module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-72x72-214fec5ed52ddc40be0db42bc9d11a3d.png";